

import { Component, OnInit } from '@angular/core';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Router, ActivatedRoute } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { CommonService } from "../../../common/common.service";
import { NgxSpinnerService } from "ngx-spinner";
import { HttpResponse } from "@angular/common/http";
import { PlanService } from "../plan.service"
import Swal from "sweetalert2";
@Component({
  selector: 'app-edit-plan',
  templateUrl: './edit-plan.component.html',
  styleUrls: ['./edit-plan.component.scss']
})
export class EditPlanComponent implements OnInit {


  coursePlanResponse: any;
  planForm: FormGroup;
  formSubmitted: boolean = false;
  showDesciptionError: boolean = true;
  featureList = [];
  finalFeatureList = [];
  temp: any;
  desciptionName: string;
  planId: string;
  planRequest = {
    coursePlanId: null,
    title: null,
    subTitle: null,
    price: null,
    featureList: [],
    sortOrder: null
  }
  constructor(
    private router: Router,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private commonService: CommonService,
    private PlanService: PlanService
  ) { }

  ngOnInit() {
    this.planId = this.route.snapshot.params["plan_id"];
    this.initialiseForms();
    this.getplanById();

  }

  getplanById() {
    this.spinner.show();
    let query = "plan_id=" + this.planId;
    this.PlanService.getplanListById(query).subscribe(res => {
      if ((res["message"] = "Success")) {
        this.coursePlanResponse = res.data;
        this.updateForm();
        this.spinner.hide();
      } else {
        this.spinner.hide();
        Swal.fire({
          type: "error",
          title: "Error",
          text: res.msg
        });
      }
    }, err => {
      this.spinner.hide();
    });

  }

  AddFeature() {

    this.featureList.push({ description: this.planForm.value.desciptionName.trim() })
    if (this.featureList.length > 0) {
      this.showDesciptionError = false;
      this.planForm.controls['desciptionName'].setValue(" ");
    }
  }

  initialiseForms() {
    this.planForm = this.fb.group({
      title: ["", [Validators.required]],
      subTitle: ["", [Validators.required]],
      desciptionName: ["", [Validators]],
      price: [, [Validators.required]],
      sortOrder: [, [Validators.required]],

    });
  }


  updateForm() {
    this.planForm.patchValue({
      title: this.coursePlanResponse["title"],
      subTitle: this.coursePlanResponse["subTitle"],
      price: this.coursePlanResponse["price"],
      sortOrder: this.coursePlanResponse["sortOrder"]
    });
    this.coursePlanResponse.featureList.forEach((element, index) => {
      this.featureList.push({ description: element.description, sortOrder: index });
    });

    this.showDesciptionError = false;

  }





  Addplan() {
    if (this.planForm.valid) {

      this.featureList.forEach((element, index) => {
        this.finalFeatureList.push({ description: element.description, sortOrder: index });
      });
      this.planRequest.coursePlanId = this.planId;
      this.planRequest.title = this.planForm.value.title;
      this.planRequest.subTitle = this.planForm.value.subTitle;
      this.planRequest.price = this.planForm.value.price;
      this.planRequest.sortOrder = this.planForm.value.sortOrder;
      this.planRequest.featureList = this.finalFeatureList;
      this.PlanService.Editplan(this.planRequest).subscribe(data => {
        if ((data["message"] = "Success")) {
          Swal.fire("Success", "Plan Updated Successfully!", "success");
          this.router.navigate(["/main/plan-management/view-plan"]);
        } else {
          Swal.fire({
            type: "error",
            title: "Error",
            text: data.msg
          });
        }
      });
    }



  }

  cancel() {
    this.router.navigate(["/main/plan-management/view-plan"]);
  }
  resetFeature() {
    this.featureList = [];
    this.planForm.controls['desciptionName'].setValue(" ");
    this.showDesciptionError = true;
  }
  drop(event: CdkDragDrop<string[]>) {

    if (event.isPointerOverContainer == false) {

      let tempValue = this.featureList[event.currentIndex];
      this.planForm.controls['desciptionName'].setValue(tempValue.description);
      this.featureList.splice(event.currentIndex, 1);
    }
    moveItemInArray(this.featureList, event.previousIndex, event.currentIndex);
  }
}

